/**
 * O caminho de volta dos autos para o acervo como ele estava: a busca, o filtro
 * de vencimento que veio do painel (`?q=`, `?vence_de=&vence_ate=`) e a página (`?pagina=`). O acervo põe
 * a própria query no `state` da navegação; os autos a devolvem no "Voltar".
 */

export type EstadoDoAcervo = { acervo: string };

/** O `state` a levar do acervo para os autos (nada, quando o acervo não tem filtro). */
export function estadoDoAcervo(params: URLSearchParams): EstadoDoAcervo | undefined {
  const query = params.toString();
  return query ? { acervo: query } : undefined;
}

/** A URL do acervo para o "Voltar". Aceita o formato antigo (`{ q }`), de abas já abertas. */
export function urlDeVoltaAoAcervo(state: unknown): string {
  const s = (state ?? {}) as { acervo?: unknown; q?: unknown };
  if (typeof s.acervo === 'string' && s.acervo) {
    // Só os parâmetros do acervo: o state vem do histórico do navegador.
    const params = new URLSearchParams(s.acervo);
    const limpos = new URLSearchParams();
    for (const chave of ['q', 'vence_de', 'vence_ate', 'pagina']) {
      const valor = params.get(chave);
      if (valor) limpos.set(chave, valor);
    }
    const query = limpos.toString();
    return query ? `/app/processos?${query}` : '/app/processos';
  }
  if (typeof s.q === 'string' && s.q) return `/app/processos?q=${encodeURIComponent(s.q)}`;
  return '/app/processos';
}
